import { createSlice } from "@reduxjs/toolkit";
import { get_background_category_dropdown_data, get_country, get_regions, get_theme_categories_dropdown, get_theme_tag_dropdown, logout, get_theme_hashtag_dropdown, get_keys_category_dropdown_data, get_theme_color_dropdown, get_history_filterList, get_History_ById, get_sticker, get_sticker_category_dropdown_data, get_sticker_pack_dropDown, get_sticker_category_dropdown, get_sticker_store_dropdown, get_homeScreen_redirection_dropdown, get_version_dropdown, get_sticker_tags_dropdown } from "../Controller/rtkActions";

export const apiSlice = createSlice({
  name: 'api',
  initialState: {
    errorMessage: '',
    customSectionData: [],
    backgroundCategoryDropdownData: [],

    analysisCategoryDropdownData: [],
    stickerStoreDropdownData: [],
    keysCategoryDropdownData: [],
    countryData: [],
    regionData: [],
    stickerTagsDropdownData: [],
    themeCategoryDropdown: [],

    themeTagsDropdown: [],
    themeHashtagDropdown: [],
    getBlogList: [],
    getBlogCommentsList: [],
    getBlogCategoriesList: [],
    getHomescreenRedirectionList: [],
    getThemeColorsDropdown: [],
    getFeedbackDropdownlist: [],
    analysisCategoryDropdown: [],
    getHistoryById: [],
    historyFilterData: {},
    categoryDropData: [],
    avtarCategoryDropdownData: [],
    stickerCategoryDropdownData: [],
    stickerPackDropdownData: [],
    avatarDropdownData: [],
    stickerDropdownData: [],
    versionDropdownData: []

  },
  reducers: {
    setLdapCheck: (state, action) => {
      state.ldapCheck = action.payload;
    },
    setDefaultLdapServerId: (state, action) => {
      state.defaultLdapServerId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //---------------------------------------------------------------------- project -----------------------------------------
      .addCase(logout.fulfilled, (state, action) => {
      })
      .addCase(get_background_category_dropdown_data.fulfilled, (state, action) => {
        state.backgroundCategoryDropdownData = action.payload;
      })
      .addCase(get_keys_category_dropdown_data.fulfilled, (state, action) => {
        state.keysCategoryDropdownData = action.payload;
      })
      .addCase(get_country.fulfilled, (state, action) => {
        state.countryData = action.payload;
      })
      .addCase(get_regions.fulfilled, (state, action) => {
        state.regionData = action.payload;
      })
      .addCase(get_theme_categories_dropdown.fulfilled, (state, action) => {
        state.themeCategoryDropdown = action.payload;
      })
      .addCase(get_theme_tag_dropdown.fulfilled, (state, action) => {
        state.themeTagsDropdown = action.payload;
      })
      .addCase(get_sticker_tags_dropdown.fulfilled, (state, action) => {
        state.stickerTagsDropdownData = action.payload;
      })
      .addCase(get_theme_hashtag_dropdown.fulfilled, (state, action) => {
        state.themeHashtagDropdown = action.payload;
      })
      .addCase(get_theme_color_dropdown.fulfilled, (state, action) => {
        state.getThemeColorsDropdown = action.payload;
      })
      .addCase(get_history_filterList.fulfilled, (state, action) => {
        state.historyFilterData = action.payload;
      })
      .addCase(get_History_ById.fulfilled, (state, action) => {
        state.getHistoryById = action.payload;
      })
      .addCase(get_sticker_store_dropdown.fulfilled, (state, action) => {
        state.stickerStoreDropdownData = action.payload;
      })
      .addCase(get_sticker_pack_dropDown.fulfilled, (state, action) => {
        state.stickerPackDropdownData = action.payload;
      })
      .addCase(get_sticker_category_dropdown.fulfilled, (state, action) => {
        state.categoryDropData = action.payload;
      })
      .addCase(get_sticker_category_dropdown_data.fulfilled, (state, action) => {
        state.stickerCategoryDropdownData = action.payload;
      })
      .addCase(get_sticker.fulfilled, (state, action) => {
        state.stickerDropdownData = action.payload;
      })
      .addCase(get_homeScreen_redirection_dropdown.fulfilled, (state, action) => {
        state.getHomescreenRedirectionList = action.payload;
      })
      .addCase(get_version_dropdown.fulfilled, (state, action) => {
        state.versionDropdownData = action.payload;
      })
  }
})
export const {
} = apiSlice.actions;

export default apiSlice.reducer;